// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__d5CZ5","footer":"styles_footer__IB7Oq","passCodeTooltip":"styles_passCodeTooltip__3QM0V"};